import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './ImportWaiting.module.scss';
import Loading from '../../../../../components/Loading';

type Props = {
  label?: string;
}

const ImportWaiting: React.FC<Props> = ({ label }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      <Loading />
      <div className={styles.tip}>{label || t('waiting_confirm')}</div>
    </div>
  );
};

export default ImportWaiting;
